<!-- The form element allows us to register enter presses as click on default button -->
<form [formGroup]="modalRef.modalForm">
  <div class="scg-modal-title">
    <span [id]="'modal-' + uniqueId + '-title'">
      <ng-container *ngIf="modalRef.modalConfig.stringsAreTranslationKeys; else noTranslationTitle">
        {{modalRef.modalConfig.title | translate}}
      </ng-container>
      <ng-template #noTranslationTitle>
        {{modalRef.modalConfig.title}}
      </ng-template>
    </span>
    <button
      *ngIf="modalRef.modalConfig.closeOnBackdropClick"
      type="button"
      class="scg-icon-button scg-icon-button-hover"
      aria-label="Close"
      [disabled]="modalRef.modalConfig.buttons !== ModalButtons.None && (modalRef.buttonsDisabled[modalRef.modalConfig.defaultCancelButton] || modalRef.buttonsLoading[modalRef.modalConfig.defaultCancelButton])"
      (click)="onButtonClick(ModalCloseReason.BackdropClick)"
    >
      <app-svg-icon [name]="'times'"></app-svg-icon>
    </button>
  </div>
  <div class="scg-modal-content" [id]="'modal-' + uniqueId + '-description'">
    <ng-container [ngSwitch]="contentType">
      <!-- Modal content is string -->
      <ng-container *ngSwitchCase="'string'">
        <p [innerHTML]="modalRef.modalConfig.stringsAreTranslationKeys ? (contentString | translate) : contentString"></p>
      </ng-container>
      <!-- Modal content is component -->
      <ng-container *ngSwitchCase="'component'">
        <ng-container *ngComponentOutlet="modalRef.content; injector: componentInjector"></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="modalButtons !== ModalButtons.None" class="scg-modal-footer">
    <!--
      Note: cdkFocusInitial is used here to focus the default button. But modal content may override cdkFocusInitial by applying it on another element
      (the first occurence of cdkFocusInitial is chosen by Angular CDK)
    -->
    <ng-container *ngIf="modalButtons === ModalButtons.YesNo || modalButtons === ModalButtons.YesNoCancel">
      <button
        *appBtnLoading="modalRef.buttonsLoading[ModalButton.Yes]"
        class="btn"
        [ngClass]="isDefaultButton(ModalButton.Yes) ? 'btn-primary' : 'btn-secondary'"
        [attr.type]="isDefaultButton(ModalButton.Yes) ? 'submit' : 'button'"
        [attr.cdkFocusInitial]="isDefaultButton(ModalButton.Yes) ? '' : null"
        [disabled]="modalRef.buttonsDisabled[ModalButton.Yes] || isSubmitButtonAndInvalid(ModalButton.Yes)"
        (click)="onButtonClick(ModalCloseReason.Yes)"
      >
        {{'BUTTON.YES' | translate}}
      </button>
    </ng-container>
    <ng-container *ngIf="modalButtons === ModalButtons.YesNo || modalButtons === ModalButtons.YesNoCancel">
      <button
        *appBtnLoading="modalRef.buttonsLoading[ModalButton.No]"
        class="btn"
        [ngClass]="isDefaultButton(ModalButton.No) ? 'btn-primary' : 'btn-secondary'"
        [attr.type]="isDefaultButton(ModalButton.No) ? 'submit' : 'button'"
        [attr.cdkFocusInitial]="isDefaultButton(ModalButton.No) ? '' : null"
        [disabled]="modalRef.buttonsDisabled[ModalButton.No] || isSubmitButtonAndInvalid(ModalButton.No)"
        (click)="onButtonClick(ModalCloseReason.No)"
      >
        {{'BUTTON.NO' | translate}}
      </button>
    </ng-container>
    <ng-container *ngIf="modalButtons === ModalButtons.OkCancel || modalButtons === ModalButtons.YesNoCancel">
      <button
        *appBtnLoading="modalRef.buttonsLoading[ModalButton.Cancel]"
        class="btn"
        [ngClass]="isDefaultButton(ModalButton.Cancel) ? 'btn-primary' : 'btn-secondary'"
        [attr.type]="isDefaultButton(ModalButton.Cancel) ? 'submit' : 'button'"
        [attr.cdkFocusInitial]="isDefaultButton(ModalButton.Cancel) ? '' : null"
        [disabled]="modalRef.buttonsDisabled[ModalButton.Cancel] || isSubmitButtonAndInvalid(ModalButton.Cancel)"
        (click)="onButtonClick(ModalCloseReason.Cancel)"
      >
        {{'BUTTON.CANCEL' | translate}}
      </button>
    </ng-container>
    <ng-container *ngIf="modalButtons === ModalButtons.Ok || modalButtons === ModalButtons.OkCancel">
      <button
        *appBtnLoading="modalRef.buttonsLoading[ModalButton.Ok]"
        class="btn"
        [ngClass]="isDefaultButton(ModalButton.Ok) ? 'btn-primary' : 'btn-secondary'"
        [attr.type]="isDefaultButton(ModalButton.Ok) ? 'submit' : 'button'"
        [attr.cdkFocusInitial]="isDefaultButton(ModalButton.Ok) ? '' : null"
        [disabled]="modalRef.buttonsDisabled[ModalButton.Ok] || isSubmitButtonAndInvalid(ModalButton.Ok)"
        (click)="onButtonClick(ModalCloseReason.Ok)"
      >
        {{'BUTTON.OK' | translate}}
      </button>
    </ng-container>
  </div>
</form>
